import { render } from "./CompanyMenuLinks.vue?vue&type=template&id=add6f546&ts=true"
import script from "./CompanyMenuLinks.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanyMenuLinks.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Navigation/CompanyMenuLinks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "add6f546"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('add6f546', __exports__)) {
    console.log('reload')
    api.reload('add6f546', __exports__)
  }
  
  module.hot.accept("./CompanyMenuLinks.vue?vue&type=template&id=add6f546&ts=true", () => {
    console.log('re-render')
    api.rerender('add6f546', render)
  })

}


export default __exports__